import { IndianRupee, TrendingDown, TrendingUp, UserPlus } from "lucide-react";
import React from "react";
import Charts from "./charts";
import DirectSalesCard from "./DirectSalesCard";
import UserPointsCard from "./UserPointsCard";
export default function Overview() {
  return (
    <div className="px-4 py-8 bg-[#0B0D0F] h-[100vh] max-sm:h-[81vh] overflow-auto space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
        {/* Total Monthly Sale */}
        <div className="bg-gradient-to-tr from-[#0F131A] to-[#171D26] px-6 py-5 rounded-lg space-y-6">
          <div className="flex justify-between items-center w-full">
            <div>
              <h1 className="text-[#9DA6AF]">Total Monthly Sale</h1>
              <p className="text-3xl text-white">₹40,689</p>
            </div>
            <div className="w-12 h-12 flex rounded-lg justify-center items-center bg-gradient-to-tr from-[#FBD150] to-[#FAB938]">
              <IndianRupee className="w-6 h-6" />
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <div className="inline-flex rounded-xl bg-[rgba(22,162,73,0.2)] h-6 px-2 gap-2 items-center justify-center text-[#16A249]">
              <TrendingUp className="w-4 h-4" />
              8.5%
            </div>
            <p className="text-[#9DA6AF]">Up from yesterday</p>
          </div>
        </div>
        {/* Direct Sale */}
        <div className="bg-gradient-to-tr from-[#0F131A] to-[#171D26] px-6 py-5 rounded-lg space-y-6">
          <div className="flex justify-between items-center w-full">
            <div>
              <h1 className="text-[#9DA6AF]">Direct Sale</h1>
              <p className="text-3xl text-white">₹10,689</p>
            </div>
            <div className="w-12 h-12 flex rounded-lg justify-center items-center bg-gradient-to-tr from-[#16A249] to-[#14B85E]">
              <TrendingUp className="w-6 h-6 text-white" />
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <div className="inline-flex rounded-xl bg-[rgba(22,162,73,0.2)] h-6 px-2 gap-2 items-center justify-center text-[#16A249]">
              <TrendingUp className="w-4 h-4" />
              8.5%
            </div>
            <p className="text-[#9DA6AF]">Up from past week</p>
          </div>
        </div>
        {/* Passive Sale */}
        <div className="bg-gradient-to-tr from-[#0F131A] to-[#171D26] px-6 py-5 rounded-lg space-y-6">
          <div className="flex justify-between items-center w-full">
            <div>
              <h1 className="text-[#9DA6AF]">Passive Sale</h1>
              <p className="text-3xl text-white">₹89,000</p>
            </div>
            <div className="w-12 h-12 flex rounded-lg justify-center items-center bg-gradient-to-tr from-[#F59F0A] to-[#F9971F]">
              <IndianRupee className="w-6 h-6" />
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <div className="inline-flex rounded-xl bg-[rgba(230,77,77,0.2)] h-6 px-2 gap-2 items-center justify-center text-[#E64D4D]">
              <TrendingDown className="w-4 h-4" />
              8.5%
            </div>
            <p className="text-[#9DA6AF]">Down from yesterday</p>
          </div>
        </div>
        {/* New Students Joined */}
        <div className="bg-gradient-to-tr from-[#0F131A] to-[#171D26] px-6 py-5 rounded-lg space-y-6">
          <div className="flex justify-between items-center w-full">
            <div>
              <h1 className="text-[#9DA6AF]">New Students Joined</h1>
              <p className="text-3xl text-white">2,040</p>
            </div>
            <div className="w-12 h-12 flex rounded-lg justify-center items-center bg-gradient-to-tr from-[#0F131A] to-[#171D26] shadow-[0_0_40px_0_rgba(251,209,80,0.15)]">
              <UserPlus className="w-6 h-6 text-white" />
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <div className="inline-flex rounded-xl bg-[rgba(22,162,73,0.2)] h-6 px-2 gap-2 items-center justify-center text-[#16A249]">
              <TrendingUp className="w-4 h-4" />
              8.5%
            </div>
            <p className="text-[#9DA6AF]">Up from yesterday</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 max-sm:grid-cols-1 lg:grid-cols-2 gap-4 w-full">
        <Charts></Charts>
        <DirectSalesCard></DirectSalesCard>
      </div>
      <div className="grid gap-4 w-full">
        <UserPointsCard></UserPointsCard>
      </div>
    </div>
  );
}
